// angular
import { Component, effect, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// components
import { SectionBarComponent } from '@app/core/components/section-bar/section-bar.component';
import { HelpCardComponent } from '@app/core/components/help-card/help-card.component';
// service
import { HelpService } from '../shared/services/help.service';
// interfaces
import {
  IHelpData,
  IHelpTopic,
} from '../shared/interfaces/help-data.interface';

@Component({
  selector: 'pwj-help-list',
  standalone: true,
  imports: [
    TranslateModule,
    SectionBarComponent,
    HelpCardComponent,
  ],
  templateUrl: './help-list.component.html',
  styleUrl: './help-list.component.scss',
})
export class HelpListComponent {
  public helps: IHelpData[] = [];
  public helpTopics: IHelpTopic[] = [];

  // dependencies
  private readonly _helpService = inject(HelpService);

  constructor() {
    // fetch helps data
    this._helpService.getHelpData();
    effect(() => {
      this.helps = this._helpService.helpsData();
    });

    // fetch help topics
    this._helpService.getHelpTopics();
    effect(() => {
      this.helpTopics = this._helpService.helpTopics();
    });
  }
}
